import * as automapper from 'automapper-ts';

export function configureAutomapper() {
    // automapper.initialize(configFunction: (config: IConfiguration) => void): void;

    automapper
        .createMap('product-ext', 'product')
        .forMember('id', function (opts) { opts.mapFrom('productId'); })
        .forMember('code', function (opts) { opts.mapFrom('code'); })
        .forMember('description', function (opts) { opts.mapFrom('name'); })
        .forMember('monthlyPaymentMinAmountPerMonth', function (opts) { opts.mapFrom('monthFee'); })
        .forMember('monthlyPaymentMaxYearCount', function (opts) { opts.mapFrom('annualInstallments'); })
        .forMember('price', function (opts) { opts.mapFrom('regularPrice'); })
        .forMember('discount', function (opts) { opts.mapFrom('discountOfv'); })
        .forMember('isNew', function (opts) { opts.mapFrom('nnew'); })
        .forMember('hasOffer', function (opts) { opts.mapFrom('offer'); })
        .forMember('sapCode', function (opts) { opts.mapFrom('sapCode'); })
        .forMember('subCategoryId', function (opts) { opts.mapFrom('subCategoryId'); })
        .forMember('categoryId', function (opts) { opts.mapFrom('categoryId'); })
        .forMember('brandId', function (opts) { opts.mapFrom('brandId'); })
        .forMember('sectionId', function (opts) { opts.mapFrom('sectionId'); })
        .forMember('featureList', function (opts) { opts.mapFrom('productsFeatureList'); })
        .forMember('category', function (opts) { opts.mapFrom('category'); })
        .forMember('monthlyPaymentModeList', function (opts) { opts.mapFrom('productFeeList'); })
        .forMember('imageList', function (opts) { opts.mapFrom('productImages'); })
        .ignoreAllNonExisting();

    automapper
        .createMap('feature-ext', 'feature')
        .forMember('description', function (opts) { opts.mapFrom('description'); })
        .ignoreAllNonExisting();

    automapper
        .createMap('image-ext', 'image')
        .forMember('id', function (opts) { opts.mapFrom('id'); })
        .forMember('base64', function (opts) { opts.mapFrom('base64image'); })
        .forMember('url', function (opts) { opts.mapFrom('routeImage'); })
        .forMember('isMain', function (opts) { opts.mapFrom('state'); })
        .ignoreAllNonExisting();

    automapper
        .createMap('monthlyPaymentMode-ext', 'monthlyPaymentMode')
        .forMember('monthCount', function (opts) { opts.mapFrom('description'); })
        .forMember('amountPerMonth', function (opts) { parseFloat(opts.mapFrom('amount')); })
        .ignoreAllNonExisting();

    automapper
        .createMap('category-ext', 'category')
        .forMember('code', function (opts) { opts.mapFrom('categoryId'); })
        .forMember('description', function (opts) { opts.mapFrom('description'); })
        .forMember('tcea', function (opts) { opts.mapFrom('tcea'); })
        .forMember('active', function (opts) { opts.mapFrom('state'); })
        .forMember('contractClauseUrl', function (opts) { opts.mapFrom('contract_clauseURL'); })
        .forMember('attentionPolicyUrl', function (opts) { opts.mapFrom('attention_policyURL'); })
        .forMember('imageUrl', function (opts) { opts.mapFrom('fileImage'); })
        .ignoreAllNonExisting();

    /**Mapea la propiedad que contiene los datos a un modelo de la aplicación */
    function map(resolutionContext): any {
        let object = {};
        if (resolutionContext.sourceValue.statusCode !== undefined) {
            Object.keys(resolutionContext.sourceValue).forEach(key => {
                if (key != "statusCode" && key != "messageError") {
                    if (Object.keys(resolutionContext.sourceValue).length > 3) object[key] = resolutionContext.sourceValue[key];
                    else return object = resolutionContext.sourceValue[key];

                }
            });
        } else {
            object = resolutionContext.sourceValue;
        }

        return object;
    }
}








// /**Mapea la propiedad que contiene los datos a un modelo de la aplicación */
// function map(resolutionContext): any {
//     let object = {};
//     if (Object.keys(resolutionContext.sourceValue).length == 3) {
//         Object.keys(resolutionContext.sourceValue).forEach(key => {
//             if (key != "statusCode" && key != "messageError") {
//                 switch (key) {
//                     case "financeBodyScheduledModel": {
//                         object = automapper.map('financing-ext', 'financing', resolutionContext.sourceValue[key]);
//                         break;
//                     }
//                     case "paymentScheduleBodyScheduledModel": {
//                         object = automapper.map('payment-schedule-ext', 'payment-schedule', resolutionContext.sourceValue[key]);
//                         break;
//                     }
//                     case "requestBodyScheduledModel": {
//                         object = automapper.map('service-request-ext', 'service-request', resolutionContext.sourceValue[key]);
//                         break;
//                     }
//                     case "requestDetailBodyScheduledModel": {
//                         object = automapper.map('service-request-detail-ext', 'service-request-detail', resolutionContext.sourceValue[key]);
//                         break;
//                     }
//                     default: {
//                         object = resolutionContext.sourceValue[key];
//                         break;
//                     }
//                 }
//             }
//         });
//     } else if (Object.keys(resolutionContext.sourceValue).length > 3) {
//         // object = automapper.map('credit-line-ext', 'credit-line', resolutionContext.sourceValue);
//         Object.keys(resolutionContext.sourceValue).forEach(key => {
//             if (key != "statusCode" && key != "messageError") object[key] = resolutionContext.sourceValue[key];
//         });
//     }
//     return object;
//  }

 // automapper
    //     .createMap('payment-schedule-ext', 'payment-schedule')
    //     .forMember('number', function (opts) { opts.mapFrom('fee'); })
    //     .forMember('baseAmount', function (opts) { opts.mapFrom('stock'); })
    //     .forMember('dueAmount', function (opts) { opts.mapFrom('amountFee'); })
    //     .forMember('dueDate', function (opts) { opts.mapFrom('dueDate'); })
    //     .forMember('interest', function (opts) { opts.mapFrom('interest'); })
    //     .forMember('state', function (opts) { opts.mapFrom('state'); })
    //     .forMember('financingId', function (opts) { opts.mapFrom('financeId'); });

    // automapper
    //     .createMap('credit-line-ext', 'credit-line')
    //     .forMember('approvedAmount', function (opts) { opts.mapFrom('approvedLineParse'); })
    //     .forMember('usedAmount', function (opts) { opts.mapFrom('consumedLineParse'); })
    //     .forMember('availableAmount', function (opts) { opts.mapFrom('availableLineParse'); })
    //     .forMember('currencySymbol', function (opts) { opts.mapFrom('symbol'); })
    //     .ignoreAllNonExisting();

    // automapper
    // .createMap('service-request-ext', 'service-request')
    // .forMember('id', function (opts) { opts.mapFrom('requestId'); })
    // .forMember('accountId', function (opts) { opts.mapFrom('supplyId'); })
    // .forMember('operationId', function (opts) { opts.mapFrom('operationId'); })
    // .forMember('operationNumber', function (opts) { opts.mapFrom('operationNumber'); })
    // .forMember('type', function (opts) { opts.mapFrom('requestType'); })
    // .forMember('date', function (opts) { opts.mapFrom('requestDate'); })
    // .forMember('state', function (opts) { opts.mapFrom('state'); })
    // .ignoreAllNonExisting();

    // automapper
    //     .createMap('service-request-detail-ext', 'service-request-detail')
    //     .forMember('date', function (opts) { opts.mapFrom('date'); })
    //     .forMember('state', function (opts) { opts.mapFrom('state'); })
    //     .forMember('comment', function (opts) { opts.mapFrom('comment'); })
    //     .ignoreAllNonExisting();

    // automapper
    //     .createMap('payment-schedule-ext', 'payment-schedule')
    //     .convertUsing(function (resolutionContext: AutoMapperJs.IResolutionContext) {
    //         return {
    //             valid: resolutionContext.sourceValue.valid,
    //             message: resolutionContext.sourceValue.message,
    //             data: resolutionContext.sourceValue.data.map((element) => {
    //                 return ({
    //                     number: element.fee,
    //                     baseAmount: element.stock,
    //                     dueAmount: element.amountFee,
    //                     dueDate: element.dueDate,
    //                     interest: element.interest,
    //                     state: element.state,
    //                     financingId: element.financeId
    //                 })
    //             })
    //         }
    //     });